import type { App, Component } from 'vue';

import { createApp } from 'vue';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        tmsShowModal: (component: Component, params?: Record<string, unknown>) => Promise<unknown>;
    }
}

const TmsModalPlugin = {
    install(app: App) {
        app.mixin({
            methods: {
                async tmsShowModal<T = unknown>(
                    ModalComponent: Component,
                    params?: Record<string, unknown>,
                ): Promise<T> {
                    const modalApp = createApp(ModalComponent, params);

                    Object.assign(modalApp._context, app._context);

                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    const response = await modalApp.mount('#modal-root').show();
                    modalApp.unmount();
                    return response;
                },
            },
        });
    },
};

export default TmsModalPlugin;
